import { useEffect, useState } from 'react';

import { useTranslation } from 'react-i18next';

import { createCustomContext } from '@utils';
import { useLocation, useNavigate } from '@utils/hooks';
import { LocationStateType } from '@utils/types';

import { loginActions, useStore } from '@modules';

export const { withCustomProvider, useCustomContext } = createCustomContext(() => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [{ user }, dispatch] = useStore();
  const kycStatus = user.data?.checks.document;
  const checkEnabled = user.data?.checks.document_details.check_enabled;
  const [isStarted, setIsStarted] = useState(false);
  const location = useLocation<LocationStateType['verifyIdentity']>();
  const { state } = location;

  const onBack = () => navigate(state?.from || CONST.nav.wallets);

  const startKYC = () => setIsStarted(true);
  const stopKYC = () => setIsStarted(false);

  const logout = () => dispatch(loginActions.logout());

  useEffect(() => {
    if (kycStatus === 'complete') onBack();
  }, [kycStatus]);

  return { t, isStarted, startKYC, stopKYC, onBack, logout, kycStatus, checkEnabled };
});
